import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GetActiveLicense } from "../../../actions/LicenseActions";
import {
  GetUploads,
  GetOneUpload,
  QueryUpload,
  GetUploadDetail,
  AbortUpload,
  GetMoreUploads,
  DownloadFail,
  ReprocessDoc,
  QueryUploadGetMore
} from "../../../actions/UploadTrackerActions";
import UploadTrackerStore from "../../../stores/UploadTrackerStore";
import { UploadQuery, UploadQueryGetMore } from "../../../models/admin/UploadTracker";
class UploadTrackerView extends React.Component {
  //private interval: any;
  constructor() {
    super();
    this.state = {
      validLicense: true,
      currentUploads: [],
      sourceFilter: "ALL",
      statusFilter: "ALL",
      useQuery: false,
      showDialog: false,
      currentInfo: void 0,
      currentTracker: void 0,
      currentOCRInfo: void 0,
      currentTab: "Documents",
      searchText: "",
      linkPath: "",
      bottomHeight: window.innerHeight - 400
    };
    this.onUploadUpdate = this.onUploadUpdate.bind(this);
    this.onChangeSourceFilter = this.onChangeSourceFilter.bind(this);
    this.onChangeStatusFilter = this.onChangeStatusFilter.bind(this);
    this.onQuerySearch = this.onQuerySearch.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
    this.onClickUploadLink = this.onClickUploadLink.bind(this);
    this.onCloseDialog = this.onCloseDialog.bind(this);
    this.tabButtonClassDocuments = this.tabButtonClassDocuments.bind(this);
    this.onClickDocumentTab = this.onClickDocumentTab.bind(this);
    this.onClickMessagesTab = this.onClickMessagesTab.bind(this);
    this.showMore = this.showMore.bind(this);
    this.onSearchTextChange = this.onSearchTextChange.bind(this);
    this.onDownloadFailClick = this.onDownloadFailClick.bind(this);
    this.onReprocessClick = this.onReprocessClick.bind(this);
    this.routeTo = this.routeTo.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }
  componentDidMount() {
    UploadTrackerStore.addChangeListener(this.onUploadUpdate);
    window.onresize = this.onWindowResize;
    GetActiveLicense(this.props.dispatch);
    GetUploads();
    document.title = "TrinDocs - Upload Tracker";
  }
  componentDidUpdate(prevProps) {
    if (prevProps.licenseInfo !== this.props.licenseInfo) {
      let lic = this.props.licenseInfo;
      let canUpload = lic.hasTrinDocsLicense === true && lic.isValid === true && lic.isExpired === false;
      this.setState({ validLicense: canUpload });
    }
  }
  onWindowResize(e) {
    let bh = window.innerHeight - 400;
    this.setState({ bottomHeight: bh });
  }
  componentWillUnmount() {
    UploadTrackerStore.removeChangeListener(this.onUploadUpdate);
    window.removeEventListener("resize", this.onWindowResize);
  }
  onUploadUpdate() {
    let lastAction = UploadTrackerStore.getLastAction();
    if (lastAction === "bulk") {
      let uploads = UploadTrackerStore.getCurrentUploads();
      this.setState({ currentUploads: uploads });
    } else if (lastAction === "detail") {
      let detail = UploadTrackerStore.getCurrentUploadInfo();
      console.log(detail);
      let tracker = UploadTrackerStore.getCurrentTracker();
      let ocrInfo = UploadTrackerStore.getCurrentOCRInfo();
      this.setState({ currentInfo: detail, currentTracker: tracker, currentOCRInfo: ocrInfo });
    } else if (lastAction === "reprocess") {
      this.setState({ showDialog: false });
      GetOneUpload(this.state.currentTracker.uploadId);
    }
  }
  onUploadOneClick(uploadId) {
    GetOneUpload(uploadId);
  }
  onAbortClick(uploadId) {
    AbortUpload(uploadId);
  }
  onQuerySearch() {
    let q = new UploadQuery();
    q.source = this.state.sourceFilter;
    q.status = this.state.statusFilter;
    q.numResult = 50;
    q.searchText = this.state.searchText;
    this.setState({ useQuery: true });
    QueryUpload(q);
  }
  onQuerySearchMoreUploads(maxId) {
    let q = new UploadQueryGetMore();
    q.source = this.state.sourceFilter;
    q.status = this.state.statusFilter;
    q.numResult = 50;
    q.searchText = this.state.searchText;
    q.maxId = maxId;
    this.setState({ useQuery: true });
    QueryUploadGetMore(q);
  }
  showMore() {
    if (this.state.currentUploads.length > 0) {
      let maxId = Math.min.apply(
        Math,
        this.state.currentUploads.map((o) => o.uploadId)
      );
      let useQuery = this.state.useQuery;
      if (useQuery) {
        this.onQuerySearchMoreUploads(maxId);
      } else {
        GetMoreUploads(maxId);
      }
    }
  }
  onRefresh() {
    let useQuery = this.state.useQuery;
    if (useQuery) {
      this.onQuerySearch();
    } else {
      GetUploads();
    }
  }
  onReprocessClick() {
    let uploadId = this.state.currentTracker.uploadId;
    ReprocessDoc(uploadId);
  }
  onChangeSourceFilter(e) {
    this.setState({ sourceFilter: e.target.value });
  }
  onSearchTextChange(e) {
    this.setState({ searchText: e.target.value });
  }
  RouteToDoc(e, docId) {
    if (e.ctrlKey) {
      window.open("/Document/" + docId.toString());
    } else {
      this.routeTo("/Document/" + docId.toString());
    }
  }
  routeTo(path) {
    this.setState({ linkPath: path }, () => {
      var link = document.getElementById("nextDocLink");
      console.log(this.state.linkPath);
      link.click();
    });
  }
  onChangeStatusFilter(e) {
    this.setState({ statusFilter: e.target.value });
  }
  onClickUploadLink(id) {
    GetUploadDetail(id);
    this.setState({ showDialog: true });
  }
  onClickDocumentTab() {
    this.setState({ currentTab: "Documents" });
  }
  onClickMessagesTab() {
    this.setState({ currentTab: "Messages" });
  }
  onCloseDialog() {
    this.setState({ showDialog: false });
  }
  onDownloadFailClick() {
    DownloadFail(
      this.state.currentTracker.uploadId,
      this.state.currentTracker.originalName
    );
  }
  onTimerClick() {
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column h-100",
        style: { backgroundColor: "#efefef", width: "100%" }
      },
      /* @__PURE__ */ React.createElement("div", null, !this.state.validLicense && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "alert alert-warning",
          role: "alert",
          style: { padding: "18px" }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-exclamation-triangle" }),
        " Your license is currently expired. License are required for intake"
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxWidth: "500px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Upload Search")),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginBottom: "8px" } }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Source"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.sourceFilter,
            onChange: this.onChangeSourceFilter
          },
          /* @__PURE__ */ React.createElement("option", { value: "ALL" }, "All"),
          /* @__PURE__ */ React.createElement("option", { value: "IA" }, "InboundAutomation"),
          /* @__PURE__ */ React.createElement("option", { value: "WEB" }, "Web Upload"),
          /* @__PURE__ */ React.createElement("option", { value: "DIR" }, "File Watch"),
          /* @__PURE__ */ React.createElement("option", { value: "FEED" }, "Direct feed"),
          /* @__PURE__ */ React.createElement("option", { value: "MOBILE" }, "Mobile"),
          /* @__PURE__ */ React.createElement("option", { value: "FILLABLE" }, "Fillable Form")
        )), /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Status"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.statusFilter,
            onChange: this.onChangeStatusFilter
          },
          /* @__PURE__ */ React.createElement("option", { value: "ALL" }, "All"),
          /* @__PURE__ */ React.createElement("option", { value: "IMP" }, "Importing"),
          /* @__PURE__ */ React.createElement("option", { value: "REG" }, "Registered"),
          /* @__PURE__ */ React.createElement("option", { value: "REJ" }, "Rejected"),
          /* @__PURE__ */ React.createElement("option", { value: "FAIL" }, "Fail")
        ))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginBottom: "8px" } }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Search for:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "searchTexttxt",
            value: this.state.searchText,
            style: { width: "300px" },
            onChange: this.onSearchTextChange
          }
        ))), /* @__PURE__ */ React.createElement("div", { className: "clearfix" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: "btn btn-primary btn-lg float-start",
            onClick: this.onQuerySearch
          },
          "Search"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            type: "button",
            className: "btn btn-info float-end",
            style: { marginLeft: "6px" },
            onClick: this.onRefresh
          },
          /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-sync" }),
          " Refresh"
        )))
      )),
      /* @__PURE__ */ React.createElement("div", { className: "flex-fill", style: { margin: "8px" } }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: `${this.state.bottomHeight}px`
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, "Uploads")),
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "card-body",
            style: {
              overflowY: "auto",
              overflow: "scroll",
              maxHeight: "20%"
            }
          },
          /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("table", { className: "tdGrid" }, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Id"), /* @__PURE__ */ React.createElement("th", null, "Source"), /* @__PURE__ */ React.createElement("th", null, "Original Name"), /* @__PURE__ */ React.createElement("th", null, "Upload Time"), /* @__PURE__ */ React.createElement("th", null, "Status"), /* @__PURE__ */ React.createElement("th", null, "Intake Step"), /* @__PURE__ */ React.createElement("th", null, "Page Count"), /* @__PURE__ */ React.createElement("th", { style: { textAlign: "center" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-ellipsis-h" }))), this.state.currentUploads !== void 0 && this.state.currentUploads.map((upload) => /* @__PURE__ */ React.createElement(
            "tr",
            {
              key: upload.uploadId,
              style: { borderTop: "1pt solid #A1A1A1" }
            },
            /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
              "span",
              {
                className: "link",
                onClick: () => this.onClickUploadLink(upload.uploadId)
              },
              upload.uploadId
            ), " "),
            upload.source === "InboundAutomation" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-regular fa-envelope-open"
              }
            ), " ", "InboundAutomation"),
            upload.source === "Fillable" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-edit" }), " ", "Fillable"),
            upload.source === "Mobile" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-mobile-screen-button"
              }
            ), " ", "Mobile"),
            upload.source === "WebUpload" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-upload" }), " Web Upload"),
            upload.source === "FileWatch" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-folder-open" }), " ", "File Watch"),
            upload.source === "NonOCRUpload" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
              "i",
              {
                className: "fa-solid fa-angle-double-right"
              }
            ), " ", "Direct Feed"),
            upload.source === "FillableForm" && /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-edit" }), " ", "Fillable Form"),
            /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-file-pdf" }), " ", upload.originalName),
            /* @__PURE__ */ React.createElement("td", null, this.convertDate(upload.uploadTime)),
            upload.status === "Importing" && /* @__PURE__ */ React.createElement("td", { style: { color: "#28A7B1" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner", spin: true }), " ", "Importing"),
            upload.status === "Registered" && /* @__PURE__ */ React.createElement("td", { style: { color: "#28B156" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-file-alt" }), " ", "Registered"),
            upload.status === "Rejected" && /* @__PURE__ */ React.createElement("td", { style: { color: "#B12828" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-copy" }), " Rejected (", /* @__PURE__ */ React.createElement(
              "span",
              {
                className: "link",
                onClick: (e) => this.RouteToDoc(e, upload.rejectId)
              },
              upload.rejectId
            ), ")"),
            upload.status === "Fail" && /* @__PURE__ */ React.createElement(
              "td",
              {
                style: {
                  color: "#B12828",
                  fontWeight: 700
                }
              },
              /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-times" }),
              " Failed"
            ),
            /* @__PURE__ */ React.createElement("td", null, upload.statusDetail),
            upload.pageCount === 0 && /* @__PURE__ */ React.createElement("td", null, "unknown"),
            upload.pageCount > 0 && /* @__PURE__ */ React.createElement("td", null, upload.pageCount),
            /* @__PURE__ */ React.createElement("td", null, upload.status === "Importing" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-info btn-sm",
                title: "Refresh",
                onClick: () => this.onUploadOneClick(upload.uploadId)
              },
              /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-sync" }),
              " "
            ), /* @__PURE__ */ React.createElement(
              "button",
              {
                type: "button",
                className: "btn btn-danger btn-sm",
                title: "Abort",
                style: { marginLeft: "3px" },
                onClick: () => this.onAbortClick(upload.uploadId)
              },
              /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-stop" })
            )))
          )), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(
            "td",
            {
              colSpan: 8,
              style: {
                textAlign: "center",
                background: "#DCE9F7"
              }
            },
            " ",
            /* @__PURE__ */ React.createElement("span", { className: "link", onClick: this.showMore }, "Show More")
          )))))
        )
      )),
      this.state.showDialog && this.state.currentInfo !== void 0 && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement("div", { className: "td-dialogue card", style: { width: "800px" } }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Upload Information", /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          style: { float: "right" },
          className: "btn-close",
          onClick: this.onCloseDialog
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginBottom: "5px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-8" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "Upload Time:"), " ", this.convertDate(this.state.currentTracker.uploadTime)), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "Page Count: "), this.state.currentTracker.pageCount)), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginBottom: "5px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "Status: "), this.state.currentTracker.status), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "Documents: "), this.state.currentInfo.docs.length), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "OCR Quality: "), this.state.currentOCRInfo.ocrQuality)), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginBottom: "5px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "Intake Strategy: "), this.state.currentOCRInfo.intakeStrategy), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "Barcodes: "), this.state.currentOCRInfo.barcodes), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("span", { className: "td-dialogue-label" }, "OCR Type: "), this.state.currentOCRInfo.ocrType)), this.state.currentTracker.status === "Fail" && /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "5px" } }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-warning",
          style: { marginRight: "4px" },
          onClick: this.onDownloadFailClick
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-download" }),
        " - Download original file"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success",
          onClick: this.onReprocessClick
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-redo" }),
        " - Reprocess file"
      )), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginBottom: "5px" } }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, this.state.currentInfo.hasError && /* @__PURE__ */ React.createElement("span", { style: { color: "red" } }, "Has Errors"))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills", style: { marginBottom: "6px" } }, /* @__PURE__ */ React.createElement(
        "li",
        {
          className: "nav-item primary",
          style: { cursor: "pointer" },
          onClick: this.onClickDocumentTab
        },
        /* @__PURE__ */ React.createElement("div", { className: this.tabButtonClassDocuments("Documents") }, "Documents")
      ), /* @__PURE__ */ React.createElement(
        "li",
        {
          className: "nav-item",
          style: { cursor: "pointer" },
          onClick: this.onClickMessagesTab
        },
        /* @__PURE__ */ React.createElement("div", { className: this.tabButtonClassDocuments("Messages") }, "Messages")
      )), this.state.currentTab === "Documents" && /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "200px", overflow: "auto" } }, /* @__PURE__ */ React.createElement("table", { className: "table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "table-dark" }, /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Doc Id:"), /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Pages"), /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Split"), /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Status"))), /* @__PURE__ */ React.createElement("tbody", null, this.state.currentInfo.docs.map((doc) => /* @__PURE__ */ React.createElement("tr", { key: doc.uploadGuid }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: "link",
          onClick: (e) => this.RouteToDoc(e, doc.documentId)
        },
        doc.documentId
      )), /* @__PURE__ */ React.createElement("td", null, doc.pageCount), /* @__PURE__ */ React.createElement("td", null, doc.pageRange), /* @__PURE__ */ React.createElement("td", null, doc.documentStatus)))))), this.state.currentTab === "Messages" && /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "200px", overflow: "auto" } }, /* @__PURE__ */ React.createElement("table", { className: "table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "table-dark" }, /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Date/Time:"), /* @__PURE__ */ React.createElement("th", { scope: "col" }, "Message"))), /* @__PURE__ */ React.createElement("tbody", null, this.state.currentInfo.messages.map((msg) => /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, this.convertDate(msg.messageDtime)), /* @__PURE__ */ React.createElement("td", { style: { wordWrap: "break-word" } }, msg.message)))))), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-secondary",
          style: { marginRight: "4px" },
          onClick: this.onCloseDialog
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-times" }),
        " Close"
      ), /* @__PURE__ */ React.createElement("button", { className: "btn btn-info" }, "Refresh")))),
      /* @__PURE__ */ React.createElement(
        Link,
        {
          id: "nextDocLink",
          to: this.state.linkPath,
          style: { display: "none" }
        },
        "HiddenLink"
      )
    );
  }
  convertDate(strDate) {
    let strDate2 = strDate.toString();
    if (!strDate2.endsWith("Z")) {
      strDate2 = strDate2 + "Z";
    }
    let date = new Date(strDate2);
    let d1 = date.getDate();
    let day = d1.toString();
    let m1 = date.getMonth();
    m1 = m1 + 1;
    let mon = m1.toString();
    let year = date.getFullYear().toString();
    let h1 = date.getHours();
    let mer = "AM";
    if (h1 >= 12) mer = "PM";
    if (h1 > 12) {
      h1 = h1 - 12;
    }
    if (h1 === 0) h1 = 12;
    let h = h1.toString();
    let m = date.getUTCMinutes().toString();
    if (m.length === 1) {
      m = "0" + m;
    }
    let fulldtime = mon + "/" + day + "/" + year + " " + h + ":" + m + " " + mer;
    return fulldtime;
  }
  tabButtonClassDocuments(tab) {
    if (this.state.currentTab === tab) {
      return "nav-link active";
    } else {
      return "nav-link";
    }
  }
}
const mapStateToProps = (state) => ({
  licenseInfo: state.licenseInfo.value
});
export default connect(mapStateToProps)(UploadTrackerView);
